module.exports = __webpack_public_path__ + "static/media/CBDD5C4C-B3FA-41A9-A952-A14ABD66E536.5888aa0a.jpeg";